<template>
	<v-menu
		:value="showMenu"
		offset-y
		bottom
		left
		:close-on-content-click="false"
		max-width="300"
		@input="changeShowMenu"
	>
		<template v-slot:activator="{ on, attrs }">
			<div
				class="seen-by-avatars"
				v-bind="attrs"
				v-on="on"
			>
				<div
					v-for="(seenUser, index) in seenByUsers.slice(0, 5)"
					:key="index"
					class="seen-avatar"
					:style="{ zIndex: 5 - index }"
				>
					<img
						v-if="seenUser.user?.basic_info?.avatar"
						:src="seenUser.user.basic_info.avatar"
						class="avatar-img"
						:title="seenUser.user?.name || ''"
					/>
					<div
						v-else
						class="avatar-initial"
						:title="seenUser.user?.name || ''"
					>
						{{ (seenUser.user?.name || '?').charAt(0).toUpperCase() }}
					</div>
				</div>
				<div
					v-if="seenByUsers.length > 5"
					class="seen-avatar more-indicator"
				>
					<div class="avatar-initial">
						+{{ seenByUsers.length - 5 }}
					</div>
				</div>
			</div>
		</template>
		<v-card>
			<v-card-title class="py-2 px-3 d-flex align-center justify-space-between" style="background-color: #f5f7fa;">
				<div>
					<span class="text-primary font-weight-bold body-2">
						{{ label }} {{ seenByUsers.length }} {{ seenByUsers.length === 1 ? 'persona' : 'personas' }}
					</span>
				</div>
				<v-btn icon x-small @click="closeSeenByMenu()">
					<v-icon size="18" color="#2D4B95">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-list dense style="max-height: 300px; overflow-y: auto;">
				<v-list-item
					v-for="(seenUser, index) in seenByUsers"
					:key="index"
				>
					<v-list-item-avatar size="32">
						<img
							v-if="seenUser.user?.basic_info?.avatar"
							:src="seenUser.user.basic_info.avatar"
						/>
						<div
							v-else
							class="avatar-initial-menu"
						>
							{{ (seenUser.user?.name || '?').charAt(0).toUpperCase() }}
						</div>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title class="text-primary font-weight-bold caption">
							{{ seenUser.user?.name || 'Usuario' }}
						</v-list-item-title>
						<v-list-item-subtitle class="caption">
							{{ seenUser.user?.email || '' }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	name: 'SeenByUsers',
  model: {
    prop: 'showMenu',
    event: 'input'
  },
	props: {
		showMenu: {
			type: Boolean,
			default: false,
		},
		seenByUsers: {
			type: Array,
			required: true,
		},
		label: {
			type: String,
			default: 'Visto por',
		},
	},
	methods: {
		closeSeenByMenu() {
			this.$emit('input', false);
			this.$emit('close-seen-by-menu');
		},
		changeShowMenu(value) {
			this.$emit('input', value);
			if (!value) {
				this.$emit('close-seen-by-menu');
			}
		},
	},
}
</script>

<style scoped>
/* Seen By Avatars */
.seen-by-avatars {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-left: 8px;
  transition: transform 0.2s ease;
}
.seen-by-avatars:hover {
  transform: scale(1.05);
}
.seen-avatar {
  position: relative;
  margin-left: -8px;
  transition: margin-left 0.2s ease;
}
.seen-by-avatars:hover .seen-avatar {
  margin-left: 2px;
}
.seen-avatar:first-child {
  margin-left: 0;
}
.avatar-img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
  display: block;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.avatar-initial {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-color: #2D4B95;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.more-indicator .avatar-initial {
  background-color: #5E85EF;
  font-size: 9px;
}
.avatar-initial-menu {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #2D4B95;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}
</style>